import { render } from "./SidebarSongs.vue?vue&type=template&id=0c82f663&scoped=true"
import script from "./SidebarSongs.vue?vue&type=script&lang=js"
export * from "./SidebarSongs.vue?vue&type=script&lang=js"

import "./SidebarSongs.vue?vue&type=style&index=0&id=0c82f663&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c82f663"]])

export default __exports__